import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import ProviderAffiliationService from "@app/projects/providerAffiliationsService";

export interface AffiliationsVersionResult {
  affiliationsVersion: number | null;
  affiliationsVersionLoading: boolean;
}

export const AFFILIATIONS_VERSION_QUERY_KEY_PREFIX = "benchmarking-affiliations-version";

export const useAffiliationsVersion = (enabledFeatureFlags: Set<string>): AffiliationsVersionResult => {
  const providerAffiliationService = useMemo(() => new ProviderAffiliationService(), []);
  const enabledFeatureFlagsKey = Array.from(enabledFeatureFlags).sort().join(",");

  const queryResult = useQuery<number>({
    queryFn: ({ signal }) => providerAffiliationService.GetActiveProviderAffiliationVersion(signal),
    queryKey: [AFFILIATIONS_VERSION_QUERY_KEY_PREFIX, enabledFeatureFlagsKey],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    affiliationsVersion: queryResult.data || null,
    affiliationsVersionLoading: queryResult.isFetching,
  };
}

export default useAffiliationsVersion;
